import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Package, ArrowLeft } from "lucide-react";
import logoIcon from "@/assets/regard-de-nature-logo.png";

export default function ProductSuccess() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    const confirmPayment = async () => {
      const sessionId = searchParams.get("session_id");
      const orderId = searchParams.get("order_id");
      const sessionCartId = localStorage.getItem("regard_de_nature_cart_session");

      if (!sessionId || !orderId) {
        setLoading(false);
        return;
      }

      try {
        const { error } = await supabase.functions.invoke("confirm-product-payment", {
          body: { sessionId, orderId, sessionCartId },
        });

        if (!error) {
          setConfirmed(true);
          localStorage.removeItem("regard_de_nature_cart_session");
        }
      } catch (err) {
        console.error("Error confirming payment:", err);
      } finally {
        setLoading(false);
      }
    };

    confirmPayment();
  }, [searchParams]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-hero flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-hero flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-card">
        <CardHeader className="text-center">
          <img src={logoIcon} alt="REGARD DE NATURE" className="w-16 h-16 mx-auto mb-4" />
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <CardTitle className="text-2xl text-primary">Commande confirmée !</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <div className="flex items-center justify-center gap-2 text-muted-foreground">
            <Package className="w-5 h-5" />
            <span>Votre commande est en cours de préparation</span>
          </div>
          <p className="text-sm text-muted-foreground">
            Un email de confirmation vous a été envoyé avec les détails de votre commande.
          </p>
          <Link to="/">
            <Button className="w-full mt-4">
              <ArrowLeft className="mr-2 w-4 h-4" />
              Retour à l'accueil
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
